export interface UpdateProfilePayload {
    phone_contact: string;
    phone_whatsapp: string;
    name?: string;
    lastname?: string;
    user_id_for_update?: number;
    update_for_customer?: boolean;
}

export const updateProfile = async (
    payload: UpdateProfilePayload,
    token: string
) => {
    const url = `${process.env.REACT_APP_GLOBAL_USERS}update_profile?country=MX`;
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_USERS_XAPIKEY,
        },
        body: JSON.stringify(payload),
    };
    const res = await fetch(url, requestOptions);
    return res.json();
};
